module.exports = __webpack_public_path__ + "img/crypto-xrp.078f2d72.svg";